package com.example.mystybag.login.model

data class MerchantForgotPasswordEmailUIState(
    val email: String = "",
    val emailErrorMsg: String = "",
    val emailIsError: Boolean = false,
    val isLoading: Boolean = false
)
